require('./strong-smooth-scroll');
module.exports = 'StrongSmoothScroll';
